(function($){

	var homeHeroSlider = function() {
		$('.hero-slider').slick({
			arrows: false,
			// prevArrow: '<button class="slick-arrow slick-prev" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.93 70"><polygon points="20.77 70 8.15 35.01 20.93 0 13.02 0 0 35 13.02 70 20.77 70"/></svg></button>',
			// nextArrow: '<button class="slick-arrow slick-next" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.93 70"><polygon points=".16 0 12.78 34.99 0 70 7.91 70 20.93 35 7.91 0 .16 0"/></svg></button>',
			dots: false,
			fade: true,
			speed: 2000,
			autoplay: true,
			autoplaySpeed: 4000,
			pauseOnHover: false
		});
	};

	var heroVideo = function() {

		videoSize('.hero-video-container');

		$('[data-action="hero-popup-play"]').on('click', function(e) {
			e.preventDefault();

			var heroVideoModal = document.getElementById('hero-video-modal');
			var heroVideoModalObj = $('#hero-video-modal');

			$.magnificPopup.open({
				mainClass: 'hero-popup',
				items: {
					src: '#hero-video-modal-container',
					type: 'inline',
				},
				callbacks: {
					open: function() {
						if(heroVideoModalObj.length){
							heroVideoModal.play();
						}
					},
					close: function() {
						if(heroVideoModalObj.length){
							heroVideoModal.pause();
							heroVideoModal.currentTime = 0;
						}
					},
				}
			}, 0);
			
		});
		
		$('[data-action="hero-popup-embed"]').magnificPopup({
			type: 'iframe',
			// mainClass: 'hero-popup'
			iframe: {
				patterns: {
					youtube: {
						index: 'youtube.com/',
						id: 'v=',
						src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0'
					}
				}
			}
		});

	};

	var videoSize = function (videoContainerSelector) {
		var videoContainer = $(videoContainerSelector);
	
		if( videoContainer.length > 0){

			var vidType = '';
			var videoContainerWidth = videoContainer.outerWidth();
			var videoContainerHeight = videoContainer.outerHeight();
			var videoContainerRatio = videoContainerHeight / videoContainerWidth;
			var vidObj = videoContainer.find('.hero-video');
			var vidEl;
			var vidRatio = 0;
			
			if(videoContainer.find("video").length > 0){
				vidType = 'video';
				// vidObj = videoContainer.find("video");
				
				vidEl = document.getElementById('videoembed');
				vidRatio = vidEl.videoHeight / vidEl.videoWidth;
			}
			else if(videoContainer.find("iframe").length > 0){
				vidType = 'iframe';
				// vidObj = videoContainer.find('videoembed');

				vidEl = document.getElementById('videoframe');
				// vidRatio = vidEl.offsetHeight / vidEl.offsetWidth;
				vidRatio = 0.5625;
			}
			else{
				return;
			}
			// var vidEl = document.getElementById(vidObj.attr("id"));
			// var vidRatio = vidEl.videoHeight / vidEl.videoWidth;

			if (isNaN(vidRatio) || vidRatio == 0) {
				vidRatio = 0.5625;
			}

			var videoResize = function () {
				videoContainerWidth = videoContainer.outerWidth();
				videoContainerHeight = videoContainer.outerHeight();
				videoContainerRatio = videoContainerHeight / videoContainerWidth;

				if(vidType == 'video'){
					vidRatio = vidEl.videoHeight / vidEl.videoWidth;
				}
				else if(vidType == 'iframe'){
					vidRatio = 0.5625;
				}

				if (isNaN(vidRatio) || vidRatio == 0) {
					vidRatio = 0.5625;
				}

				if (videoContainerRatio <= vidRatio) {
					vidObj.removeClass("tall");
					vidObj.addClass("wide");
					vidObj.css({
						'height' : (vidRatio*100)+'vw',
						'width' : ''
					});
					// console.log();
				} else {
					vidObj.removeClass("wide");
					vidObj.addClass("tall");
					vidObj.css({
						'height' : '',
						'width' : (videoContainerHeight / vidRatio)
					});
				}
			};

			videoResize();
			optimizedResize.add(videoResize);
		}
	};



	var scrollAnim = function(){

		///** convert to use intersectionObserver **///

		var win = $(window);

		var items = $('.scroll-animate-item');

		var itemScrollCheck = function(){

			var winHeight = win.innerHeight();
			var winTop = win.scrollTop();
			var scrollTriggerPos = (winHeight * .8) + winTop;

			items.each(function(i, el){

				var item = $(el);
				var itemTop = item.offset().top;

				if(itemTop <= scrollTriggerPos){
					item.addClass('vis');
				}
				else{
					item.removeClass('vis');
				}

			});

		};

		itemScrollCheck();
		optimizedScroll.add(itemScrollCheck);
	};


	var scrollToAnchor = function(){

		if( location.hash ){
			// window.scrollTo(0,0);

			$( 'body' ).removeClass( 'nav-open' );
			
			var locationHashObj = $(location.hash);
			
			if(locationHashObj.length > 0){
				//$('body').removeClass('nav-open');
				// $('body,html').animate({
				// 	scrollTop: locationHashObj.offset().top - 150
				// }, 500);

				var waitTime = 100;

				// if(!$('body').hasClass('scrolled')){
				// 	waitTime = 501;
				// 	$('body').addClass('scrolled');
				// }

				setTimeout(function(){
					var anchorPosition = locationHashObj.offset().top;
					var finalPosition = anchorPosition - $('.site-header').outerHeight() - 20;
					$("html, body").animate({scrollTop: finalPosition}, 1000);

				}, waitTime);
			}
		}

		$('.scroll-to-anchor a, a[href^="#"], .menu a').on('click', function(e){

			if($(this).hasClass('no-scroll')){
				return;
			}
			else if(this.hash){
				
				var hashTarget = $(this.hash);

				if( hashTarget.length ){
					e.preventDefault();
					var waitTime = 100;
					
					// if(!$('body').hasClass('scrolled')){
					// 	waitTime = 501;
					// 	$('body').addClass('scrolled');
					// }

					setTimeout(function(){
						var anchorPosition = hashTarget.offset().top;
						var finalPosition = anchorPosition - $('.site-header').outerHeight() - 20;
						$("html, body").animate({scrollTop: finalPosition}, 1000);

						$( 'body' ).removeClass( 'nav-open' );

					}, waitTime);
				}
			}
		});
	};

	var blockGallery = function() {

		// in gutenberg: "Link images to media files"
		$('.wp-block-gallery').magnificPopup({
			delegate: 'a',
			type: 'image',
			gallery: {
				enabled: true
			}
		});


		$('.wp-block-gallery.slider').slick({
			arrows: true,
			// prevArrow: '#people-slider-arrow-prev',
			// nextArrow: '#people-slider-arrow-next',
			prevArrow: '<button class="slick-prev" type="button"><svg width="24" height="55" viewBox="0 0 24 55" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.4719 1.66667C17.1861 0.627706 18.355 0 19.632 0C22.7273 0 24.5455 3.4632 22.8139 5.99567L9.50217 25.3247C8.59307 26.6234 8.59307 28.355 9.50217 29.6537L22.8139 49.0043C24.5671 51.5368 22.7489 55 19.6537 55C18.3983 55 17.2078 54.3723 16.4935 53.3333L1.03896 30.8225C-0.324675 28.8312 -0.324675 26.1905 1.03896 24.1775L16.4719 1.66667Z" fill="#DC4A4A"/></svg></button>',
			nextArrow: '<button class="slick-next" type="button"><svg width="24" height="55" viewBox="0 0 24 55" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.01304 1.66667C6.29876 0.627706 5.12993 0 3.85287 0C0.757632 0 -1.06055 3.4632 0.671051 5.99567L13.9827 25.3247C14.8918 26.6234 14.8918 28.355 13.9827 29.6537L0.671051 49.0043C-1.0822 51.5368 0.735987 55 3.83122 55C5.08664 55 6.27711 54.3723 6.9914 53.3333L22.4459 30.8225C23.8096 28.8312 23.8096 26.1905 22.4459 24.1775L7.01304 1.66667Z" fill="#DC4A4A"/></svg></button>',
			dots: true,
			speed: 1000,
			autoplay: false,
			autoplaySpeed: 2000,
			pauseOnHover: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			adaptiveHeight: true,
		});

		$('.home-intro-gallery').slick({
			arrows: false,
			// prevArrow: '#people-slider-arrow-prev',
			// nextArrow: '#people-slider-arrow-next',
			// prevArrow: '<button class="slick-prev" type="button"><svg width="24" height="55" viewBox="0 0 24 55" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.4719 1.66667C17.1861 0.627706 18.355 0 19.632 0C22.7273 0 24.5455 3.4632 22.8139 5.99567L9.50217 25.3247C8.59307 26.6234 8.59307 28.355 9.50217 29.6537L22.8139 49.0043C24.5671 51.5368 22.7489 55 19.6537 55C18.3983 55 17.2078 54.3723 16.4935 53.3333L1.03896 30.8225C-0.324675 28.8312 -0.324675 26.1905 1.03896 24.1775L16.4719 1.66667Z" fill="#DC4A4A"/></svg></button>',
			// nextArrow: '<button class="slick-next" type="button"><svg width="24" height="55" viewBox="0 0 24 55" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.01304 1.66667C6.29876 0.627706 5.12993 0 3.85287 0C0.757632 0 -1.06055 3.4632 0.671051 5.99567L13.9827 25.3247C14.8918 26.6234 14.8918 28.355 13.9827 29.6537L0.671051 49.0043C-1.0822 51.5368 0.735987 55 3.83122 55C5.08664 55 6.27711 54.3723 6.9914 53.3333L22.4459 30.8225C23.8096 28.8312 23.8096 26.1905 22.4459 24.1775L7.01304 1.66667Z" fill="#DC4A4A"/></svg></button>',
			// dots: true,
			fade: true,
			speed: 1000,
			autoplay: true,
			autoplaySpeed: 2000,
			pauseOnHover: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			// adaptiveHeight: true,
		});
	};

	var peopleSlider = function() {
		$('.people-slider').slick({
			arrows: true,
			prevArrow: '#people-slider-arrow-prev',
			nextArrow: '#people-slider-arrow-next',
			// prevArrow: '<button class="slick-prev" type="button"><svg width="24" height="55" viewBox="0 0 24 55" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.4719 1.66667C17.1861 0.627706 18.355 0 19.632 0C22.7273 0 24.5455 3.4632 22.8139 5.99567L9.50217 25.3247C8.59307 26.6234 8.59307 28.355 9.50217 29.6537L22.8139 49.0043C24.5671 51.5368 22.7489 55 19.6537 55C18.3983 55 17.2078 54.3723 16.4935 53.3333L1.03896 30.8225C-0.324675 28.8312 -0.324675 26.1905 1.03896 24.1775L16.4719 1.66667Z" fill="#DC4A4A"/></svg></button>',
			// nextArrow: '<button class="slick-next" type="button"><svg width="24" height="55" viewBox="0 0 24 55" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.01304 1.66667C6.29876 0.627706 5.12993 0 3.85287 0C0.757632 0 -1.06055 3.4632 0.671051 5.99567L13.9827 25.3247C14.8918 26.6234 14.8918 28.355 13.9827 29.6537L0.671051 49.0043C-1.0822 51.5368 0.735987 55 3.83122 55C5.08664 55 6.27711 54.3723 6.9914 53.3333L22.4459 30.8225C23.8096 28.8312 23.8096 26.1905 22.4459 24.1775L7.01304 1.66667Z" fill="#DC4A4A"/></svg></button>',
			dots: false,
			speed: 1000,
			autoplay: false,
			autoplaySpeed: 4000,
			pauseOnHover: false,
			slidesToShow: 2,
			slidesToScroll: 2,
			adaptiveHeight: true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					}
				}
			]
		});
	};

	var testimonialsSlider = function() {
		$('.testimonials-slider').slick({
			arrows: true,
			prevArrow: '#testimonials-slider-arrow-prev',
			nextArrow: '#testimonials-slider-arrow-next',
			dots: false,
			speed: 1000,
			autoplay: false,
			autoplaySpeed: 4000,
			pauseOnHover: false,
			asNavFor: '.testimonials-img-slider',
			adaptiveHeight: true
		});

		$('.testimonials-img-slider').slick({
			arrows: false,
			// prevArrow: '<button class="slick-arrow slick-prev" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.93 70"><polygon points="20.77 70 8.15 35.01 20.93 0 13.02 0 0 35 13.02 70 20.77 70"/></svg></button>',
			// nextArrow: '<button class="slick-arrow slick-next" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.93 70"><polygon points=".16 0 12.78 34.99 0 70 7.91 70 20.93 35 7.91 0 .16 0"/></svg></button>',
			dots: false,
			speed: 1000,
			fade: true,
			autoplay: false,
			autoplaySpeed: 4000,
			pauseOnHover: false,
			asNavFor: '.testimonials-slider'
		});
	};

	var homeTabs = function() {
		$('[data-action="home-tab-nav"]').on('click', function(e) {
			e.preventDefault();

			var targetId = this.hash;
			var targetEl = $(targetId);

			// console.log(targetId);

			$(this).parents('li').addClass('active');
			targetEl.addClass('active');

			$('.tabs-nav').find('li').not($(this).parents('li')).removeClass('active');
			$('.tabs').find('.tab').not(targetEl).removeClass('active');
		});
	};

	var eventGallery = function() {
		$('.event-images-gallery').magnificPopup({
			delegate: 'a',
			type: 'image',
			gallery: {
				enabled: true
			}
		});
	};

	var topPadding = function() {
		var headerheight = $('.site-header').outerHeight();
		$('#MainContent').css('paddingTop', headerheight);

		// console.log(headerheight );
	};


	var studentGallery = function() {

		$('.student-gallery').magnificPopup({
			delegate: 'a',
			type: 'image',
			gallery: {
				enabled: true
			}
		});

		// $('.gallery-thumbs').on('click', '[data-action="thumb"]', function(e) {
		// 	e.preventDefault();
			
		// 	var thisGallery = $(this).parents('.gallery').find('.gallery-main');
		// 	// var thisHref = this.href;
		// 	var thisHref = $(this).attr('href');
		// 	var thisIndex = $(this).attr('data-index');
		// 	var thisSrc = $(this).find('img').attr('src');

		// 	thisGallery.find('a').attr('href', thisHref);
		// 	thisGallery.find('a').attr('data-index', thisIndex);
		// 	thisGallery.find('img').attr('src', thisSrc);
		// });

		// // 2. Initialize Magnific Popup on gallery click
		// $('.gallery-main').on('click', '[data-action="gallery"]', function(e) {
		// 	e.preventDefault();

		// 	var thisIndex = parseInt($(this).attr('data-index'));

		// 	// Get all image URLs dynamically
		// 	var items = $(this).parents('.gallery').find('.gallery-thumbs').find('a').map(function() {
		// 		return {
		// 			src: $(this).attr('href'),
		// 			type: 'image'
		// 		};
		// 	}).get();

		// 	// console.log(thisIndex);

		// 	// Open Magnific Popup
		// 	$.magnificPopup.open({
		// 		items: items,
		// 		gallery: {
		// 			enabled: true,
		// 		},
		// 		type: 'image'
		// 	}, thisIndex);
		// });
	};

	var scheduleFilter = function() {

		$('[data-action="schedule-filter-display"]').on('click', function(e) {
			$(this).toggleClass('vis');
			$('.schedule-filter-checkbox-list').toggleClass('vis');
		});

		var checkboxList = $('.schedule-filter-checkbox-list');
		
		$('[data-action="schedule-group-checkbox"]').on('change', function(e) {
			var thisChecked = $(this).prop('checked');
			var targetClass = $(this).data('target');
			var target;

			if(targetClass == 'all'){
				target = $('.schedule-filter-checkbox-list').find('input[type="checkbox"]').not(this);
			}
			else{
				target = $('input[type="checkbox"].'+targetClass);
			}

			if(thisChecked == true){
				target.prop('checked', true).change();
			}
			else{
				target.prop('checked', false).change();
				$('#schedule-all').prop('checked', false);
			}
		});


		$('[data-action="schedule-level-checkbox"]').on('change', function(e) {
		    var checkedBoxes = checkboxList.find('input[type="checkbox"]:checked');
		    var allLevels = $('.level');
		    allLevels.removeClass('vis');
		    $('.schedule-table-group').removeClass('vis');
		    
		    // Reset alternating classes on all levels first
		    allLevels.removeClass('odd even');
		    $(this).parents('.term').removeClass('checked');
		    
		    $(this).parents('.term').find('[data-action="schedule-group-checkbox"]').prop('checked', true);
		    $(this).parents('.term').find('[name="schedule-level"]').each(function(i,el) {

	            if($(this).prop('checked') == false){
		    		$(this).parents('.term').find('[data-action="schedule-group-checkbox"]').prop('checked', false);
	            }
		    });
		    
		    if (checkedBoxes.length > 0) {
		        checkedBoxes.each(function(i, el) {
		            var targetClass = $(el).attr('id');
		            $('.level.' + targetClass).addClass('vis');
		            $('.level.' + targetClass).parents('.schedule-table-group').addClass('vis');
		            
		            if($(this).prop('checked') == true){
		   				// $(this).parents('.term').find('[data-action="schedule-group-checkbox"]').prop('checked', true);
		            	$(this).parents('.term').addClass('checked');
		            }
		            else{
		            }
		        });
		    }
		    else {
		        allLevels.removeClass('vis');
		    }
		    
		    // Now alternate colors only on visible .level elements
		    var visibleLevels = $('.level.vis');
		    visibleLevels.each(function(i, el) {
		        if (i % 2 === 0) {
		            $(el).addClass('odd').removeClass('even');
		        } else {
		            $(el).addClass('even').removeClass('odd');
		        }
		    });
		});

		$('[data-action="schedule-go-to-group"]').on('click', function(e) {
			e.preventDefault();
			$(this).removeClass('vis');
			$('.schedule-filter-checkbox-list').removeClass('vis');
			$('[data-action="schedule-filter-display"]').removeClass('vis');

			var hashTarget = $(this.hash);

			if( hashTarget.length ){

				setTimeout(function(){
					var anchorPosition = hashTarget.offset().top;
					var finalPosition = anchorPosition - $('.site-header').outerHeight() - 20;
					$("html, body").animate({scrollTop: finalPosition}, 1000);

				}, 500);
			}
		});
	};

	var eventFilters = function() {

		if($('#event-filters-form').length){

			var eventsFilterForm = $('#event-filters-form');

			$('input#event-filter-date-range').daterangepicker({
				// autoApply: false,
				autoUpdateInput: false,
				// minDate: moment(),
				locale: {
					cancelLabel: 'Clear'
				}
			});
			$('input#event-filter-date-range').on('apply.daterangepicker', function(ev, picker) {
				$(this).val(picker.startDate.format('MM/DD/YYYY') + ' - ' + picker.endDate.format('MM/DD/YYYY'));
				eventsFilterForm.submit();
			});

			$('input#event-filter-date-range').on('cancel.daterangepicker', function(ev, picker) {
				$(this).val('');
				eventsFilterForm.submit();
			});

			// $('[data-action="filter"]').on('click', function(e) {
			// 	e.preventDefault();
			// 	var tax = $(this).data('tax');
			// 	var slug = $(this).data('slug');
			// 	eventsFilterForm.find('input[name="'+tax+'"]').val(slug);
			// });


			$('[data-action="filter"]').on('click', function(e) {
				e.preventDefault();
				var tax = $(this).data('tax');
				var slug = $(this).data('slug');
				var $filterDropdown = $(this).closest('.filter-dropdown');
				var $filterDisplay = $filterDropdown.find('.filter-display');

				// Set hidden input
				eventsFilterForm.find('input[name="' + tax + '"]').val(slug);

				// Set display text
				var termName;
				if (slug === '') {
				    // Default based on taxonomy
				    termName = (tax === 'event_category') ? 'Filter By Category' : 'Filter By Level';
				} else {
				    termName = $(this).text().trim();
				}
				$filterDisplay.text(termName);

				// Optionally auto-submit after setting (uncomment if desired)
				eventsFilterForm.submit();

			});

			// For clear button
			$('[data-action="filters-clear"]').on('click', function(e) {
				e.preventDefault();
				// Clear hidden inputs
				eventsFilterForm.find('input[name="event_category"], input[name="event_level"]').val('');
				// $('#event-filters-form input, #event-filters-form select, #event-filters-form textarea').val('');

				// Clear date input
				eventsFilterForm.find('#event-filter-date-range').val('');

				// Reset display texts to defaults
				eventsFilterForm.find('.filter-display').eq(0).text('Filter By Category');
				eventsFilterForm.find('.filter-display').eq(1).text('Filter By Level');
				// Optionally auto-submit after clear
				eventsFilterForm.submit();
			});

			$('[data-action="filter-toggle"]').on('click', function(e) {

				var targetId = $(this).data('target');
				$('#'+targetId).toggleClass('vis');

				$(this).toggleClass('open');
			});
		}
	};


	var onScroll = function() {
		// var scrollTimeout;
		// var hasScrolled = false;

		// document.addEventListener('scroll', function() {
		// 	if (scrollTimeout) {
		// 		clearTimeout(scrollTimeout);
		// 	}

		// 	scrollTimeout = setTimeout(function() {
		// 		hasScrolled = false;
		// 	}, 100);

		// 	if (!hasScrolled) {
		// 		hasScrolled = true;
				
		// 		$( 'body' ).removeClass( 'nav-open' );
		// 		$('.nav-toggle').attr('aria-pressed', 'false');
		// 	}
		// });
	};


	var accordion = function() {

		$('.accordion-section-title').on('click', function(e) {
			e.preventDefault();

			$(this).parents('.accordion-toggle').toggleClass('open');
		});
	};


	$(document).ready(function(){
        if($('body').hasClass('home')){
			homeHeroSlider();
			heroVideo();
			homeTabs();

			$('.hero-content').addClass('vis');
        }
		scrollAnim();
		scrollToAnchor();
		blockGallery();
		peopleSlider();
		testimonialsSlider();
		eventGallery();
		studentGallery();
		scheduleFilter();
		eventFilters();
		onScroll();
		accordion();
	});

    window.addEventListener('load', function() {
        var videoContainer = $('.hero-video-container');
        videoContainer.addClass('vis');

        if(!$('body').hasClass('home')){
			topPadding();
			optimizedResize.add(topPadding);
        }

    }, false);

})(jQuery);

/* Lazy load bg images https://web.dev/lazy-loading-images/ */
// document.addEventListener("DOMContentLoaded", function() {
//   var lazyBackgrounds = [].slice.call(document.querySelectorAll(".lazy-background"));

//   if ("IntersectionObserver" in window) {
//     let lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
//       entries.forEach(function(entry) {
//         if (entry.isIntersecting) {
//           entry.target.classList.add("visible");
//           lazyBackgroundObserver.unobserve(entry.target);
//         }
//       });
//     });

//     lazyBackgrounds.forEach(function(lazyBackground) {
//       lazyBackgroundObserver.observe(lazyBackground);
//     });
//   }
// });